import {Button, DeleteIcon} from '@chakra-ui/icons'
import React from 'react'

export const DeleteCountings = (props) => {
    const {isDeleting, handleDeleteCountings} = props
    return (
        <>
            <Button
                leftIcon={<DeleteIcon />}
                loadingText={'Deleting...'}
                isLoading={isDeleting}
                size={'sm'}
                colorScheme={'red'}
                onClick={handleDeleteCountings}
            >Delete</Button>
        </>
    )
}